import React from "react"
import Footer from "./Footer"
import Header from "./Header"

const Layout = ({ children }) => {
  return (
    <>
      <Header />
      {children}
      <Footer />
      <div className="hidden gallery-slider-full !mt-0 pt-0 py-60 lgscreen:py-40 !mt-0 py-90"></div>
      <a
        href="https://api.whatsapp.com/send/?phone=27608007155&amp;text=Hello%2C+I+have+visited+your+website+and+need+more+info&amp;type=phone_number&amp;app_absent=0"
        target="_blank"
        class="whatsapp-chat-link"
      >
        <img
          src="https://wp.rareearth.co.za/app/uploads/2024/09/PlatformWhatsApp-ColorNegative-1.png"
          alt="whatsapp icon"
        />
      </a>
    </>
  )
}

export default Layout
